import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {GridService} from '../basegrid/grid.service';
import {ConfigService} from '../services/config.service';
import {EventsEmitterService} from '../services/emitter.service';
import {LogService} from '../services/log.service';

@Injectable()
export class BaseSearchModalService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, '');
  }
}
